export default "__VITE_ASSET__Cclaqafz__"